import React, { useState } from "react";
import Head from "next/head";
import FeaturedBlogs from "../../../components/VLSI/featuredBlogs";
import Modal from "../../../components/VLSI/modal";
import Menu from "../../../components/VLSI/menu";
import MobileMenu from "../../../components/VLSI/mobileMenu";
import { redirectTo500 } from "../../../utils/utility";
import ghost from "../../../utils/ghost";
import Footer from "../../../components/VLSI/footer";
import MobileFooter from "../../../components/VLSI/mobileFooter";

export async function getStaticProps(context) {
  const featuredData = await ghost({
    filter: "tags:blog" + "+tags:vlsi",
    pagination: { limit: 3 },
  });
  const listPagedData = await ghost({
    filter: "tags:blog" + "+featured:false",
    pagination: { limit: "all" },
  });

  if (!featuredData || !listPagedData) {
    return redirectTo500();
  }
  return {
    props: {
      featured: featuredData,
      listData: listPagedData,
    },
    revalidate: 3600,
  };
}

const Packaging = (props) => {
  // modal state
  const [showModal, setShowModal] = useState(false);
  const handleOnClose = () => setShowModal(false);
  return (
    <div>
      <Head>
        <title>IC-Packaging | Harware Solution in Bangladesh</title>
        <meta
          name="description"
          content="DSi blog space covers the latest technologies and industry trends in eloquent articles penned by our seasoned tech enthusiasts."
        />
      </Head>
      <div className="negative-margin sticky top-0 z-50">
        <header className="hidden lg:block w-full bg-black sticky top-0 z-50">
          <Menu />
        </header>
        <header className="block lg:hidden w-full bg-black sticky top-0 z-50">
          <MobileMenu />
        </header>
      </div>
      {/* page content container */}
      {/* hero section */}
      <section className="bg-gray-50">
        <div className="flex lg:gap-24 max-w-screen-xl mx-auto items-center p-7 lg:py-16 lg:px-[30px]">
          <img
            src="/images/VLSI/ic/ic_packaging_hero_image.png"
            className="hidden lg:block"
          />
          <div className="flex flex-col gap-3 sm:gap-6">
            <div class="text-3xl sm:text-4xl lg:text-6xl text-gray-900 font-bold sm:font-black">
              IC Packaging
            </div>
            <div className="sm:text-xl text-gray-500 sm:leading-relaxed">
              Ready to embark on your IC packaging journey? Partner with us, and
              let's turn your ideas into reality. Contact us today to get
              started.
            </div>
            <div className=" mt-2 flex gap-4">
              <button
                onClick={() => {
                  setShowModal(true);
                }}
                className=" inline-flex items-center gap-2 px-5 py-3 bg-[#1A56DB] hover:bg-blue-800 text-white  "
              >
                Contact Us <img src="/images/VLSI/ic/arrow-right.svg" />
              </button>
              <a
                href="#second_section_ICPD"
                className=" inline-flex px-5 py-3 bg-gray-50 hover:bg-gray-100  border border-gray-200 "
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* modal */}
      <Modal visible={showModal} onClose={handleOnClose} />
      {/* modal ENDS */}
      {/* hero section ENDS */}
      {/* 2nd section Unlocking the Power of IC Packaging  */}
      <section id="second_section_ICPD">
        <div className="flex lg:gap-16 items-center  max-w-screen-xl mx-auto p-7 lg:py-11 lg:px-[30px]">
          <div className=" lg:basis-2/5 text-xl sm:text-4xl font-bold sm:font-extrabold text-gray-900 sm:leading-relaxed">
            Unlocking the Power of IC Packaging
            <p className="mt-2 sm:mt-4 text-base sm:text-lg text-gray-500 font-normal leading-relaxed">
              At DSi, we understand the intricate world of Integrated Circuit
              (IC) packaging and how it plays a crucial role in safeguarding the
              heart of your electronic devices. Our IC packaging services go
              beyond the conventional - we're here to ensure your innovations
              shine.
            </p>
          </div>
          <div className=" lg:basis-3/5 flex flex-col lg:flex-row gap-4 ">
            <img
              src="/images/VLSI/ic/image 1.png"
              className="hidden lg:inline-block w-full  object-contain"
              alt="Unlocking the Power of IC Packaging image one"
            />
            <img
              src="/images/VLSI/ic/image 2.png"
              className="hidden lg:inline-block w-full mt-9  object-contain"
              alt="Unlocking the Power of IC Packaging image two"
            />
          </div>
        </div>
      </section>
      {/* 2nd section Unlocking the Power of IC Packaging ENDS  */}

      {/* 3rd section DSi Package Flow */}
      <section className="bg-gray-100">
        <div className=" max-w-screen-xl mx-auto p-7 lg:py-24 lg:px-[30px]">
          <div className="text-center text-gray-900 font-bold sm:font-extrabold text-xl sm:text-4xl">
            DSi Package Flow
          </div>
          <p className="mt-2 sm:mt-4 text-center sm:text-lg text-gray-500 font-normal sm:leading-relaxed max-w-3xl mx-auto">
            We believe in thoroughness and precision at each stage of our
            package flow, ensuring your semiconductor devices are handled with
            care and expertise
          </p>

          <div className="mt-4 sm:mt-8 lg:mt-16 grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* card 1  */}
            <div className=" p-6 flex flex-col gap-2 sm:gap-4 border border-gray-200 shadow  ">
              <img
                src="/images/VLSI/ic/Silicon Initiation Assistance icon.png"
                className="w-12 h-12"
              />
              <p className="text-gray-900 text-lg font-semibold">
                Silicon Initiation Assistance
              </p>
              <p className="text-lg text-gray-500 font-normal sm:leading-relaxed">
                Kickstart your journey with our expert guidance and support.
              </p>
            </div>
            {/* card 2  */}
            <div className="p-6 flex flex-col gap-2 sm:gap-4 border border-gray-200 shadow  ">
              <img
                src="/images/VLSI/ic/Package Feasibility icon.png"
                className="w-12 h-12"
              />
              <p className="text-gray-900 text-lg font-semibold">
                Package Feasibility
              </p>
              <p className="text-lg text-gray-500 font-normal sm:leading-relaxed">
                Assess project feasibility, considering size, cost, and
                materials.
              </p>
            </div>

            {/* card 3  */}
            <div className="p-6 flex flex-col gap-2 sm:gap-4 border border-gray-200 shadow  ">
              <img
                src="/images/VLSI/ic/Package Design icon.png"
                className="w-12 h-12"
              />
              <p className="text-gray-900 text-lg font-semibold">
                Package Design
              </p>
              <p className="text-lg text-gray-500 font-normal sm:leading-relaxed">
                Craft precise and creative packaging solutions tailored to your
                needs.
              </p>
            </div>

            {/* card 4  */}
            <div className=" p-6 flex flex-col gap-2 sm:gap-4 border border-gray-200 shadow  ">
              <img
                src="/images/VLSI/ic/Package Release icon.png"
                className="w-12 h-12"
              />
              <p className="text-gray-900 text-lg font-semibold">
                Package Release
              </p>
              <p className="text-lg text-gray-500 font-normal sm:leading-relaxed">
                Ensure a seamless transition with finalized documentation and
                requirements
              </p>
            </div>
            {/* card 5  */}
            <div className="p-6 flex flex-col gap-2 sm:gap-4 border border-gray-200 shadow  ">
              <img
                src="/images/VLSI/ic/Engineering Build icon.png"
                className="w-12 h-12"
              />
              <p className="text-gray-900 font-semibold">Engineering Build</p>
              <p className="text-lg text-gray-500 font-normal sm:leading-relaxed">
                Meticulously construct packaging solutions with attention to
                detail.
              </p>
            </div>
            {/* card 6  */}
            <div className="p-6 flex flex-col gap-2 sm:gap-4 border border-gray-200 shadow  ">
              <img
                src="/images/VLSI/ic/Verification icon.png"
                className="w-12 h-12"
              />
              <p className="text-gray-900 text-lg font-semibold">
                Verification
              </p>
              <p className="text-lg text-gray-500 font-normal sm:leading-relaxed">
                Guarantee top-tier quality through rigorous testing and
                analysis.
              </p>
            </div>
            {/* card 7  */}
            <div className="p-6 flex flex-col gap-2 sm:gap-4 border border-gray-200 shadow  ">
              <img
                src="/images/VLSI/ic/Production icon.png"
                className="w-12 h-12"
              />
              <p className="text-gray-900 text-lg font-semibold">Production</p>
              <p className="text-lg text-gray-500 font-normal sm:leading-relaxed">
                From prototype to mass production, we deliver excellence.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* 3rd section DSi Package Flow ENDS */}

      {/* 4th section  */}
      <section className="bg-gray-50">
        <div className=" max-w-screen-xl mx-auto p-7 lg:py-24 lg:px-[30px]">
        <div className="text-center text-gray-900 font-bold sm:font-extrabold text-xl sm:text-4xl">
        Design Verification
          </div>
          <p className="mt-2 sm:mt-4 text-center sm:text-lg text-gray-500 font-normal sm:leading-relaxed pb-7 lg:pb-24 max-w-3xl mx-auto">
          At DSi, we ensure IC packaging integrity through rigorous design verification
and comprehensive analysis.
          </p>
          <div className="flex gap-16">
            {/* left side bar */}
            <div className="hidden lg:block basis-2/5 sticky top-20 self-start py-24">
              {/* tab-1 */}
              <a href="#initiation" className="flex gap-3 items-center text-gray-500 font-medium">
                <img
                  src="/images/VLSI/ic/Initiation_icon.svg"
                  className="w-10"
                />
                Initiation 
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -2 */}
              <a href="#package_selection" className="flex gap-3 items-center text-gray-500 font-medium">
              <img
                  src="/images/VLSI/ic/Package Selection_icon.svg"
                  className="w-10"
                />
                Package Selection 
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -3 */}
              <a href="#kickoff" className="flex gap-3 items-center text-gray-500 font-medium">
              <img
                  src="/images/VLSI/ic/Kickoff_icon.svg"
                  className="w-10"
                />
                Kickoff 
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -4 */}
              <a href="#design" className="flex gap-3 items-center text-gray-500 font-medium">
              <img
                  src="/images/VLSI/ic/Design_icon.svg"
                  className="w-10"
                />
                Design 
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -5 */}
              <a href="#design_finalization" className="flex gap-3 items-center text-gray-500 font-medium">
              <img
                  src="/images/VLSI/ic/Design finalization_icon.svg"
                  className="w-10"
                />
                Design finalization 
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -6 */}
              <a href="#first_article_preparation" className="flex gap-3 items-center text-gray-500 font-medium">
              <img
                  src="/images/VLSI/ic/First Article Preparation_icon.svg"
                  className="w-10"
                />
                First Article Preparation 
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -7 */}
              <a href="#qualification" className="flex gap-3 items-center text-gray-500 font-medium">
              <img
                  src="/images/VLSI/ic/Qualification_icon.svg"
                  className="w-10"
                />
                Qualification
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -8 */}
              <a href="#transition_to_production" className="flex gap-3 items-center text-gray-500 font-medium">
              <img
                  src="/images/VLSI/ic/Transition to Production_icon.svg"
                  className="w-10"
                />
                Transition to Production
              </a>
              {/* <div className="ml-[18px] h-12 bg-gray-100 w-[1px]"></div> */}
            </div>
            {/* left side bar ENDS */}
            {/* right side content */}
            <div className="flex flex-col gap-10">
              {/* card 1 */}
              <div id="initiation" className="bg-gray-100 p-8 lg:px-16 lg:py-24 shadow-lg">
                <div className="flex flex-col lg:flex-row items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl sm:text-4xl font-extrabold text-gray-900">
                      Initiation
                    </span>
                    <ul className="list-disc list-outside lg:leading-normal mt-4 text-gray-500 sm:text-lg flex flex-col gap-4">
                      <li>
                        We kick off our process with Sales/PM briefings to gain
                        a deep understanding of your product.
                      </li>
                      <li>
                        Customers and back-end teams submit Package Request
                        Forms, providing essential project details and
                        requirements.
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div>
                    <img src="/images/VLSI/ic/Initiation.svg" />
                  </div>
                </div>
              </div>

              {/* card 2 */}
              <div id="package_selection" className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg">
                <div className="flex flex-col lg:flex-row-reverse items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl sm:text-4xl font-extrabold text-gray-900">
                      Package Selection 
                    </span>
                    <ul className="list-disc list-outside sm:leading-relaxed mt-4 text-gray-500 sm:text-lg flex flex-col gap-4">
                      <li>
                        Expertise guides us in choosing the right package type,
                        size, and stack-up.
                      </li>
                      <li>
                        We consider cost implications, identify
                        primary/secondary suppliers, and ensure all necessary
                        tooling and materials are ready.
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div>
                    <img src="/images/VLSI/ic/Package Selection.svg" />
                  </div>
                </div>
              </div>

              {/* card 3 */}
              <div id="kickoff" className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg">
                <div className="flex flex-col lg:flex-row items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl sm:text-4xl font-extrabold text-gray-900">
                      Kickoff 
                    </span>
                    <ul className="list-disc list-outside sm:leading-relaxed mt-4 text-gray-500 sm:text-lg flex flex-col gap-4">
                      <li>
                        At the Kickoff stage, we confirm the completeness of
                        project specifications.
                      </li>
                      <li>
                        We identify any required extractions/simulations and set
                        expectations for design checkpoints.
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div>
                    <img src="/images/VLSI/ic/Kickoff.svg" />
                  </div>
                </div>
              </div>

              {/* card 4 */}
              <div id="design" className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg">
                <div className="flex flex-col lg:flex-row-reverse items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl sm:text-4xl font-extrabold text-gray-900">
                      Design
                    </span>
                    <ul className="list-disc list-outside sm:leading-relaxed mt-4 text-gray-500 sm:text-lg flex flex-col gap-4">
                      <li>
                        Design rules are meticulously identified to ensure
                        precision.
                      </li>
                      <li>
                        Critical IP undergoes a full review, and simulations,
                        including thermal and mechanical aspects, are performed.
                      </li>
                      <li>
                        Our team ensures chip lead and relevant block owners
                        approve the design.
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div>
                    <img src="/images/VLSI/ic/Design.svg" />
                  </div>
                </div>
              </div>

              {/* card 5 */}
              <div id="design_finalization" className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg">
                <div className="flex flex-col lg:flex-row items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl sm:text-4xl font-extrabold text-gray-900">
                      Design Finalization
                    </span>
                    <ul className="list-disc list-outside sm:leading-relaxed mt-4 text-gray-500 sm:text-lg flex flex-col gap-4">
                      <li>
                        We complete vital documentation such as the Package
                        Checklist, MOD for datasheets, and POD for socket
                        integration.
                      </li>
                      <li>
                        Supplier documentation is finalized, and we attend
                        pre-Tape out meetings to ensure everything is in place.
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div>
                    <img src="/images/VLSI/ic/Design Finalization.svg" />
                  </div>
                </div>
              </div>

              {/* card 6 */}
              <div id="first_article_preparation" className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg">
                <div className="flex flex-col lg:flex-row-reverse items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl sm:text-4xl font-extrabold text-gray-900">
                      First Article Preparation
                    </span>
                    <ul className="list-disc list-outside sm:leading-relaxed mt-4 text-gray-500 sm:text-lg flex flex-col gap-4">
                      <li>
                        Initial substrates are ordered, with clear communication
                        about quantity and delivery schedules.
                      </li>
                      <li>
                        We confirm the availability of all necessary tooling and
                        materials, releasing assembly instructions before wafer
                        arrival at the factory.
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div>
                    <img src="/images/VLSI/ic/First Article Preparation.svg" />
                  </div>
                </div>
              </div>

              {/* card 7 */}
              <div id="qualification" className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg">
                <div className="flex flex-col lg:flex-row items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl sm:text-4xl font-extrabold text-gray-900">
                      Qualification
                    </span>
                    <ul className="list-disc list-outside sm:leading-relaxed mt-4 text-gray-500 sm:text-lg flex flex-col gap-4">
                      <li>
                        We allocate materials for qualification and coordinate
                        the build.
                      </li>
                      <li>
                        Qualification reports are obtained, and we collaborate
                        with Product Engineering for testing.
                      </li>
                      <li>
                        Any necessary follow-ups or corrective actions are
                        addressed, and our records are updated.
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div>
                    <img src="/images/VLSI/ic/Qualification.svg" />
                  </div>
                </div>
              </div>
              {/* card 8 */}
              <div id="transition_to_production" className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg">
                <div className="flex flex-col lg:flex-row-reverse items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl sm:text-4xl font-extrabold text-gray-900">
                      Transition to Production
                    </span>
                    <ul className="list-disc list-outside sm:leading-relaxed mt-4 text-gray-500 sm:text-lg flex flex-col gap-4">
                      <li>
                        With confidence in package quality, we transition to
                        Production.
                      </li>
                      <li>
                        We complete optimization and pre-production processes,
                        ensuring seamless material management under the care of
                        our Planning team.
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div>
                    <img src="/images/VLSI/ic/Transition to Production.svg" />
                  </div>
                </div>
              </div>
            </div>
            {/* right side content ENDS */}
          </div>
        </div>
      </section>
      {/* 4th section ENDS  */}
      {/* page content container ENDS */}

      {/* featured */}
      <div className="bg-gray-100 w-full py-10 sm:py-20">
        <div className="grid mid-home-column">
          <div className="pb-12 items-center flex flex-col">
            <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
              Read what we wrote
            </h2>
            <p className="text-center flex font-headline items-center text-base md:text-xl leading-8 text-gray-600">
              Get front-row industry insights
            </p>
          </div>
          <div className="flex justify-center mx-5">
            <FeaturedBlogs
              how={props.featured.posts}
              path="/blogs/"
              title="VIEW DETAILS"
            />
          </div>
        </div>
      </div>

      {/* {showModal && <Modal />} */}
      <div className="hidden md:block md:footer-div absolute z-50 bg-black md:py-24 w-full px-10 xl:px-32">
        <Footer />
      </div>
      <div className="block md:hidden absolute z-50 bg-black py-10 w-full px-7">
        <MobileFooter />
      </div>
    </div>
  );
};

export default Packaging;